'use client';

import React from 'react';
import { StrategyListGenerator } from '../index';
import { STRATEGY_ALLOWED_TYPES } from 'src/components/DynamicCriteriaGenerator/constants';
import { LOCATION } from 'src/hooks/filters/constants';
import { StrategyConfigProps } from 'src/components/Strategy/config';

const ReferralsConfiguration: React.FC<StrategyConfigProps> = ({
  location = LOCATION.STRATEGY,
}) => {
  return (
    <div className="flex flex-col gap-4">
      <StrategyListGenerator
        allowedTypes={STRATEGY_ALLOWED_TYPES}
        strategyType="REFERRALS"
        location={location}
      />
    </div>
  );
};

export default ReferralsConfiguration;
